_ = require("lodash")

TimeSeriesAnalysisService = ($filter) ->
  convertToCategories: (filteredScorecards) ->
    _.map filteredScorecards, (ts, key) ->
      return '' unless (key == 0 || key == (filteredScorecards.length - 1))
      ts.play_date.format("YYYY/MM/DD")

  convertToSeries: (filteredScorecards) ->
    scores_data = []
    putts_data = []
    _.map filteredScorecards, (ts, key) ->
      play_date = "#{ts.play_date.format("YYYY/")}</br>#{ts.play_date.format("MM/DD")}"
      scores_data.push({ play_date: play_date, y: ts.total_shot_all_holes, id: ts.id })
      putts_data.push({ play_date: play_date, y: ts.total_putt_all_holes, id: ts.id })

    [
      name: $filter('translate')('SCORE')
      color: "#4D90B6"
      data: scores_data

    ,
      name: $filter('translate')('PUTTS')
      color: "#00C7C4"
      data: putts_data

    ]

TimeSeriesAnalysisService.$inject = [
  '$filter'
]

module.exports = TimeSeriesAnalysisService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/time-series-analysis/time-series-analysis-service.coffee